/*
Replace
recipeIngredient with your resource Name :) Take care about different writings!
/!\ RecipeIngredient recipeIngredient RecipeIngredients recipeIngredients /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const recipeIngredientSlice = createSlice({
  name: "recipeIngredients",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
  },
});

export const {
  list: listRecipeIngredients,
  show: showRecipeIngredient,
  create: createRecipeIngredient,
  update: updateRecipeIngredient,
} = recipeIngredientSlice.actions;

export const actions = recipeIngredientSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const recipeIngredients = (state) =>
  state.recipeIngredients.idsList.map(
    (id) => state.recipeIngredients.dictionary[id]
  );
export const recipeIngredient = (state) =>
  state.recipeIngredients.showId &&
  state.recipeIngredients.dictionary[state.recipeIngredients.showId];
export const recipeIngredientAttributes = (state) =>
  recipeIngredient(state)?.attributes;
export const recipeIngredientRelationships = (state) =>
  recipeIngredient(state)?.relationships;
export const recipeIngredientId = (state) => state.recipeIngredients.showId;

export const getRecipeIngredient = createSelector(
  (state) => state.recipeIngredients.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getRecipeIngredientAttributes = createSelector(
  (state) => state.recipeIngredients.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getRecipeIngredientRelationships = createSelector(
  (state) => state.recipeIngredients.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getRecipeIngredients = createSelector(
  (state) => state.recipeIngredients.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export default recipeIngredientSlice.reducer;
